import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';


@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: []
})
export class FooterComponent implements OnInit {
  VER_LOGO_GMSHOP = environment.VER_LOGO_GMSHOP;
  CLIENTE = environment.CLIENTE;
  constructor() { }

  ngOnInit(): void {
  }

}
